import { navStepAtom, productKeyAtom } from "src/atoms";
import { useRecoilState } from "recoil";
import WrapsodyAndEcoSitePromotion from "./WrapsodyAndEco/PromotionWrapsodyAndEco.container";
import PromotionDspmContainer from "./DSPM/PromotionDspm.container";
import PromotionDspContainer from "./DSP/Dsp.container";
import PromotionFiresideContainer from "./Fireside/Fireside.container";
import { useEffect } from "react";

interface ISitePayContainerProps {}

const SitePromotionContainer = () => {
  const [product, setProduct] = useRecoilState(productKeyAtom);
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  useEffect(() => {
    setNavStep(2);
  }, []);
  if (product === "DSPM") {
    return <PromotionDspmContainer />;
  } else if (product === "DSP") {
    return <PromotionDspContainer />;
  } else if (product === "FIRESIDE") {
    return <PromotionFiresideContainer />;
  } else {
    // Wrapsody, eCo
    return <WrapsodyAndEcoSitePromotion />;
  }
};

export default SitePromotionContainer;
